<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Edit Setting Interval</h1>
    </div>
    <div class="">
      <div class="form-group col-12">
        <div class="row px-3">
          <label for="#form-subject" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Interval time for user publish</label>
          <select class="form-control" v-model="interval_user_publish">
            <option v-for="index in arr_time" :value="index">{{ index }} minutes</option>
          </select>
        </div>
      </div>
      <div class="form-group col-12 text-right">
        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#preloader_modal" @click="save">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import please_wait_modal from '@/layout/please_wait_modal'
import 'summernote/dist/summernote.css'
import summernote from 'summernote'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      name: '',
      company_name: '',
      address: '',
      phone: '',
      interval_user_publish: 5,
      arr_time: [5, 10, 15, 20, 25, 30],
    }
  },
  async mounted(){
    console.log("sjadhjka")
    await this.get_data()
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.name = response_data.data.name
          this.company_name = response_data.data.company_name
          this.address = response_data.data.address
          this.phone = response_data.data.phone
          this.interval_user_publish = response_data.data.interval_user_publish
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async save(){
      try{
        if(this.name == '')
          this.$toasted.show('Name is empty')
        else if(this.company_name == '')
          this.$toasted.show('Company name is empty')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.name = this.name
          data.company_name = this.company_name
          data.address = this.address
          data.phone = this.phone
          data.interval_user_publish = this.interval_user_publish

          var response = await axios.put(base_url+'/setting',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.reload()
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    }
  }
}
</script>
